export const EMAIL_FORM = "EmailForm";
export const PASSWORD_FORM = "PasswordForm";
export const SIGN_UP_FORM = "SignUpForm";
export const COMPLETE_ACCOUNT_FORM = "CompleteAccountForm";
export const SELECT_USER_FORM = "SelectUserForm";
export const FORGOT_PASSWORD_FORM = "ForgotPasswordForm";
export const PRIVATE_NOTICE = "PrivateNotice";
export const INVITED_PASSWORD_RESET_FORM = "InvitedPasswordResetForm";
export const ACCEPT_INVITATION_PASSWORD_FORM = "AcceptInvitationPasswordForm";
export const EXPERT_SIGN_UP_FORM = "ExpertSignUpForm";
export const TWO_FACTOR_FORM = "TwoFactorForm";
export const TWO_FACTOR_ENROLL_FORM = "TwoFactorEnrollForm";

export const ACCOUNT_DELETED_ERROR_CODE = 403;
